import { Box, Container, Grid, Paper, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useIsMobile } from '../hooks/useIsMobile';

function LayoutContainer({ children, header = false }) {
  const { testName } = useSelector((state) => state.user);
  const { isMobile } = useIsMobile();

  return (
    <Container
      sx={{
        minHeight: '100dvh',
        padding: isMobile ? '0px' : '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{
          flexGrow: 1,
          maxHeight: '100dvh',
          overflow: 'auto',
          scrollBehavior: 'smooth',
          scrollbarWidth: 'thin',
          '-webkit-overflow-scrolling': 'touch', // Ensures smooth scrolling on iOS devices
        }}
      >
        <Paper
          className="container"
          sx={(theme) => ({
            maxWidth: '100%',
            backgroundColor: theme.palette.white,
          })}
        >
          {header && testName && (
            <Box
              sx={(theme) => ({
                borderBottomWidth: '1px',
                borderBottomStyle: 'solid',
                borderBottomColor: theme.palette.grey,
                padding: '10px 0',
              })}
            >
              <Stack direction="column" alignItems="center">
                <Typography variant="overline" align="center">
                  {testName}
                </Typography>
              </Stack>
            </Box>
          )}
          <Box
            sx={{
              maxWidth: '100dvw',
              margin: '24px 32px',
              overflow: 'auto',
            }}
          >
            {children}
          </Box>
        </Paper>
      </Grid>
    </Container>
  );
}

export default LayoutContainer;
